// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1c07dda8","171":"3f8e3860","388":"ddb5f10f","453":"f97c0203"}[chunkId] + ".chunk.js";
};